import { render, staticRenderFns } from "./hobies.vue?vue&type=template&id=54550111&scoped=true&"
import script from "./hobies.vue?vue&type=script&lang=js&"
export * from "./hobies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54550111",
  null
  
)

export default component.exports